import { CheckedCheckbox, ErrorIcon, UncheckedCheckbox } from '@commenda/icons';
import { Button } from '@commenda/kakashi';
import { TSetNotification } from '@commenda/types/src/random';
import { classNames, getAvatarName } from '@commenda/utils';
import React, { useState } from 'react';
import { KeyedMutator } from 'swr';
import {
  BaseDirectorType,
  DirectorFormType,
} from '../Director/DirectorFormType';
import { getDirectorName } from '../Director/common';

const DirectorCard = <DirectorType extends BaseDirectorType>({
  companyDataMutate,
  director,
  setOpen,
  isSelected,
  onSelect,
  DirectorForm,
  corporationId,
  disabled = false,
  selectDirectorById,
  setNotification,
  companyId,
  token,
  hasError,
  onErrorResolve,
}: {
  companyDataMutate: KeyedMutator<unknown>;
  director: DirectorType;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isSelected: boolean;
  onSelect: (director: DirectorType) => void;
  DirectorForm: DirectorFormType<DirectorType>;
  corporationId?: number;
  disabled?: boolean;
  selectDirectorById?: (directorId: number) => void;
  setNotification: TSetNotification;
  companyId: number;
  token: string;
  hasError: boolean;
  onErrorResolve: () => void;
}) => {
  const [isEditDirectorModalShown, setEditDirectorModalShown] = useState(false);
  const [isSubmittingDirectorInfo, setIsSubmittingDirectorInfo] =
    useState(false);

  const directorName = getDirectorName(director);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-3 items-center">
        <div className="flex items-center gap-3 grow">
          <div
            className={classNames(
              'py-3.5 px-3 border rounded-lg flex justify-between items-center hover:bg-neutral-6 transition-all select-none w-full w-[500px]',
              !disabled ? 'cursor-pointer' : '',
              hasError ? 'border-error-100' : 'border-stroke-2'
            )}
            onClick={disabled ? () => {} : () => onSelect(director)}
          >
            <div className="flex items-center gap-2">
              {isSelected ? <CheckedCheckbox /> : <UncheckedCheckbox />}
              {hasError ? (
                <ErrorIcon className="h-5 w-5 text-error-100" />
              ) : (
                <div className="h-5 w-5 bg-accent-blue-10 text-accent-blue-100 text-[10px] rounded flex justify-center items-center">
                  {getAvatarName(directorName)}
                </div>
              )}
              <span className="body-14-medium">{directorName}</span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="body-14-medium text-neutral-3">
                {director.email}
              </span>
            </div>
          </div>
        </div>
        <Button
          size="sm"
          variant="tertiary"
          onClick={(e) => {
            e.stopPropagation();
            setEditDirectorModalShown(true);
          }}
        >
          Edit
        </Button>
      </div>
      {isEditDirectorModalShown ? (
        <DirectorForm
          companyDataMutate={companyDataMutate}
          {...(director ? { director } : {})}
          isAddingDirector={isSubmittingDirectorInfo}
          setIsAddingDirector={setIsSubmittingDirectorInfo}
          setOpen={setEditDirectorModalShown}
          corporationId={corporationId}
          selectDirectorById={selectDirectorById}
          setNotification={setNotification}
          companyId={companyId}
          token={token}
          onErrorResolve={onErrorResolve}
        />
      ) : null}
    </div>
  );
};

export default DirectorCard;
